<template>
  <div class="esp-container">

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Otorrinolaringología">
      <AyudaOtorrinolaringologia />
    </Modal>

    <!-- Toolbar -->
    <div class="card mb-3">
      <div class="card-body py-2">

        <!-- Tabs editar / consultar -->
        <div class="d-flex align-items-center gap-3 mb-2 border-bottom pb-2">
          <button type="button" class="tab-modo"
            :class="modoVista === 'editar' ? 'tab-modo-active-edit' : 'tab-modo-inactive'"
            :disabled="!editable"
            @click="modoVista = 'editar'">
            <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">edit</span>
            Modo Edición
          </button>
          <button type="button" class="tab-modo"
            :class="modoVista === 'consultar' ? 'tab-modo-active-view' : 'tab-modo-inactive'"
            @click="modoVista = 'consultar'">
            <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">pageview</span>
            Modo Consulta
          </button>
          <span v-if="modoVista === 'editar'" class="badge bg-warning text-dark ms-1" style="font-size:11px">
            <span class="material-symbols-outlined" style="font-size:12px;vertical-align:middle">brush</span>
            Completa los datos clínicos del oído
          </span>
          <span v-else class="badge bg-info text-dark ms-1" style="font-size:11px">
            <span class="material-symbols-outlined" style="font-size:12px;vertical-align:middle">touch_app</span>
            Solo lectura
          </span>
        </div>

        <!-- Tabs de sección -->
        <div class="d-flex align-items-center gap-2">
          <button v-for="tab in tabs" :key="tab.key" type="button"
            class="btn btn-sm"
            :class="tabActual === tab.key ? 'btn-primary' : 'btn-outline-secondary'"
            @click="tabActual = tab.key">
            {{ tab.label }}
          </button>

          <div class="ms-auto d-flex gap-2">
            <button type="button" class="btn btn-sm btn-outline-danger"
              :disabled="!editable || modoVista === 'consultar'"
              @click="limpiarFormulario">
              <span class="material-symbols-outlined" style="font-size:16px">restart_alt</span>
              Limpiar
            </button>
            <button type="button" class="btn btn-sm btn-success"
              :disabled="!editable || guardando || modoVista === 'consultar'"
              @click="guardarOrl">
              <span class="material-symbols-outlined" style="font-size:16px">save</span>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
      <button
        class="btn-help"
        type="button"
        title="Abrir ayuda"
        @click="showModalHelp = true"
        aria-label="Abrir ayuda de otorrinolaringología"
      >
        <span class="material-symbols-outlined">help</span>
      </button>
          </div>
        </div>

      </div>
    </div>

    <!--  TAB: DATOS GENERALES  -->
    <div v-show="tabActual === 'general'">

      <!-- Identificación -->
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Identificación de la consulta</small></div>
        <div class="card-body py-2">
          <div class="row g-2">
            <div class="col-md-4">
              <label class="form-label form-label-sm">Lateralidad</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.lateralidad"
                :disabled="soloLectura">
                <option value="OD">Oído derecho (OD)</option>
                <option value="OI">Oído izquierdo (OI)</option>
                <option value="OU">Ambos oídos (OU)</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label form-label-sm">Tipo de consulta</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.tipoConsulta"
                :disabled="soloLectura">
                <option value="primera_vez">Primera vez</option>
                <option value="control">Control</option>
                <option value="urgencia">Urgencia</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Otoscopia -->
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Otoscopia</small></div>
        <div class="card-body py-2">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="oido-panel oido-od">
                <div class="oido-panel-title">
                  <span class="material-symbols-outlined" style="font-size:15px">hearing</span>
                  Oído Derecho (OD)
                </div>
                <label class="form-label form-label-sm mt-2">Membrana timpánica</label>
                <select class="form-select form-select-sm"
                  v-model="datosGenerales.membranaOd"
                  :disabled="soloLectura">
                  <option value="">— Seleccionar —</option>
                  <option value="integra">Íntegra</option>
                  <option value="perforada">Perforada</option>
                  <option value="retractil">Retráctil</option>
                  <option value="abombada">Abombada</option>
                </select>
                <label class="form-label form-label-sm mt-2">Descripción otoscópica</label>
                <textarea class="form-control form-control-sm" rows="2"
                  v-model="datosGenerales.otoscopiaOd"
                  :disabled="soloLectura"
                  placeholder="Hallazgos en OD..."/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="oido-panel oido-oi">
                <div class="oido-panel-title">
                  <span class="material-symbols-outlined" style="font-size:15px">hearing</span>
                  Oído Izquierdo (OI)
                </div>
                <label class="form-label form-label-sm mt-2">Membrana timpánica</label>
                <select class="form-select form-select-sm"
                  v-model="datosGenerales.membranaOi"
                  :disabled="soloLectura">
                  <option value="">— Seleccionar —</option>
                  <option value="integra">Íntegra</option>
                  <option value="perforada">Perforada</option>
                  <option value="retractil">Retráctil</option>
                  <option value="abombada">Abombada</option>
                </select>
                <label class="form-label form-label-sm mt-2">Descripción otoscópica</label>
                <textarea class="form-control form-control-sm" rows="2"
                  v-model="datosGenerales.otoscopiaOi"
                  :disabled="soloLectura"
                  placeholder="Hallazgos en OI..."/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Acumetría -->
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Acumetría (diapasón)</small></div>
        <div class="card-body py-2">
          <div class="row g-2">
            <div class="col-md-3">
              <label class="form-label form-label-sm">Rinne OD</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.rinneOd" :disabled="soloLectura">
                <option value="">—</option>
                <option value="positivo">Positivo</option>
                <option value="negativo">Negativo</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label form-label-sm">Rinne OI</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.rinneOi" :disabled="soloLectura">
                <option value="">—</option>
                <option value="positivo">Positivo</option>
                <option value="negativo">Negativo</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label form-label-sm">Weber lateraliza</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.weberLateraliza" :disabled="soloLectura">
                <option value="">—</option>
                <option value="derecha">Derecha</option>
                <option value="izquierda">Izquierda</option>
                <option value="centro">Centro</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label form-label-sm">Schwabach</label>
              <select class="form-select form-select-sm"
                v-model="datosGenerales.schwabach" :disabled="soloLectura">
                <option value="">—</option>
                <option value="normal">Normal</option>
                <option value="alargado">Alargado</option>
                <option value="acortado">Acortado</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Síntomas -->
      <div class="card mb-3">
        <div class="card-header py-1"><small class="fw-bold">Síntomas</small></div>
        <div class="card-body py-2">
          <div class="row g-3">

            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkAcufenos"
                    v-model="datosGenerales.acufenos" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkAcufenos">Acúfenos</label>
                </div>
                <input v-if="datosGenerales.acufenos"
                  class="form-control form-control-sm mt-1"
                  v-model="datosGenerales.acufenosDetalle"
                  :disabled="soloLectura"
                  placeholder="Describir: tono, intensidad, lateralidad..."/>
              </div>
            </div>

            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkVertigo"
                    v-model="datosGenerales.vertigo" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkVertigo">Vértigo</label>
                </div>
                <select v-if="datosGenerales.vertigo"
                  class="form-select form-select-sm mt-1"
                  v-model="datosGenerales.vertigoTipo" :disabled="soloLectura">
                  <option value="">— Tipo —</option>
                  <option value="posicional">Posicional (VPPB)</option>
                  <option value="central">Central</option>
                  <option value="periferico">Periférico</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkHipoacusia"
                    v-model="datosGenerales.hipoacusia" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkHipoacusia">Hipoacusia</label>
                </div>
                <select v-if="datosGenerales.hipoacusia"
                  class="form-select form-select-sm mt-1"
                  v-model="datosGenerales.hipoacusiaTipo" :disabled="soloLectura">
                  <option value="">— Tipo —</option>
                  <option value="conductiva">Conductiva</option>
                  <option value="sensorioneural">Sensorioneural</option>
                  <option value="mixta">Mixta</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="sintoma-row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="chkOtorrea"
                    v-model="datosGenerales.otorrea" :disabled="soloLectura">
                  <label class="form-check-label fw-bold" for="chkOtorrea">Otorrea</label>
                </div>
                <select v-if="datosGenerales.otorrea"
                  class="form-select form-select-sm mt-1"
                  v-model="datosGenerales.otorreaTipo" :disabled="soloLectura">
                  <option value="">— Tipo —</option>
                  <option value="serosa">Serosa</option>
                  <option value="purulenta">Purulenta</option>
                  <option value="mucosa">Mucosa</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="chkOtalgia"
                  v-model="datosGenerales.otalgia" :disabled="soloLectura">
                <label class="form-check-label fw-bold" for="chkOtalgia">Otalgia</label>
              </div>
            </div>

          </div>

          <div class="mt-3">
            <label class="form-label form-label-sm">Observación general</label>
            <textarea class="form-control form-control-sm" rows="2"
              v-model="datosGenerales.observacion"
              :disabled="soloLectura"
              placeholder="Observaciones adicionales..."/>
          </div>
        </div>
      </div>

      <!-- Resumen de síntomas activos -->
      <div class="card mb-3" v-if="sintomasActivos.length">
        <div class="card-body py-2 d-flex flex-wrap gap-2">
          <span v-for="s in sintomasActivos" :key="s"
            class="badge rounded-pill bg-danger">
            {{ s }}
          </span>
        </div>
      </div>

    </div>

    <!--  TAB: AUDIOMETRÍA  -->
    <div v-show="tabActual === 'audiometria'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center gap-2">
          <small class="fw-bold">Audiometría tonal</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarAudiometria">
            <span class="material-symbols-outlined" style="font-size:15px">add</span>
            Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!audiometrias.length" class="text-muted text-center py-3" style="font-size:13px">
            Sin registros de audiometría
          </div>
          <div v-for="(aud, idx) in audiometrias" :key="idx" class="audiometria-card mb-3">
            <div class="audiometria-header">
              <span class="badge" :class="aud.tipoVia === 'VA' ? 'bg-primary' : 'bg-secondary'">
                {{ aud.tipoVia === 'VA' ? 'Vía Aérea' : 'Vía Ósea' }}
              </span>
              <span class="badge ms-1" :class="aud.oido === 'OD' ? 'bg-danger' : 'bg-info text-dark'">
                {{ aud.oido === 'OD' ? 'Oído Derecho' : 'Oído Izquierdo' }}
              </span>
              <span v-if="aud.clasificacion" class="badge ms-1"
                :class="claseBadgePTA(aud.clasificacion)">
                PTA: {{ aud.pta }} dB — {{ aud.clasificacion }}
              </span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="eliminarAudiometria(idx)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Vía</label>
                <select class="form-select form-select-sm"
                  v-model="aud.tipoVia" :disabled="soloLectura">
                  <option value="VA">Vía Aérea (VA)</option>
                  <option value="VO">Vía Ósea (VO)</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Oído</label>
                <select class="form-select form-select-sm"
                  v-model="aud.oido" :disabled="soloLectura">
                  <option value="OD">Derecho (OD)</option>
                  <option value="OI">Izquierdo (OI)</option>
                </select>
              </div>
            </div>
            <!-- Tabla de frecuencias -->
            <div class="table-responsive mt-2">
              <table class="table table-sm table-bordered text-center mb-0">
                <thead class="table-light">
                  <tr>
                    <th style="font-size:11px">250 Hz</th>
                    <th style="font-size:11px">500 Hz</th>
                    <th style="font-size:11px">1000 Hz</th>
                    <th style="font-size:11px">2000 Hz</th>
                    <th style="font-size:11px">4000 Hz</th>
                    <th style="font-size:11px">8000 Hz</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="campo in ['hz250','hz500','hz1000','hz2000','hz4000','hz8000']"
                      :key="campo">
                      <input type="number" class="form-control form-control-sm text-center"
                        style="width:56px;margin:0 auto"
                        v-model.number="aud[campo]"
                        :disabled="soloLectura"
                        min="0" max="120"
                        @change="calcularPTA(aud)"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  TAB: IMPEDANCIOMETRÍA  -->
    <div v-show="tabActual === 'impedanciometria'">
      <div class="card mb-3">
        <div class="card-header py-1 d-flex align-items-center gap-2">
          <small class="fw-bold">Impedanciometría / Timpanometría</small>
          <button v-if="!soloLectura" type="button"
            class="btn btn-sm btn-outline-primary ms-auto"
            @click="agregarImpedanciometria">
            <span class="material-symbols-outlined" style="font-size:15px">add</span>
            Agregar
          </button>
        </div>
        <div class="card-body py-2">
          <div v-if="!impedanciometrias.length"
            class="text-muted text-center py-3" style="font-size:13px">
            Sin registros de impedanciometría
          </div>
          <div v-for="(imp, idx) in impedanciometrias" :key="idx" class="audiometria-card mb-3">
            <div class="audiometria-header">
              <span class="badge" :class="imp.oido === 'OD' ? 'bg-danger' : 'bg-info text-dark'">
                {{ imp.oido === 'OD' ? 'Oído Derecho' : 'Oído Izquierdo' }}
              </span>
              <span v-if="imp.tipoTimpanograma" class="badge bg-secondary ms-1">
                Tipo {{ imp.tipoTimpanograma }}
              </span>
              <button v-if="!soloLectura" type="button"
                class="btn btn-sm btn-outline-danger ms-auto py-0"
                @click="eliminarImpedanciometria(idx)">
                <span class="material-symbols-outlined" style="font-size:14px">delete</span>
              </button>
            </div>
            <div class="row g-2 mt-1">
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Oído</label>
                <select class="form-select form-select-sm"
                  v-model="imp.oido" :disabled="soloLectura">
                  <option value="OD">Derecho (OD)</option>
                  <option value="OI">Izquierdo (OI)</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label form-label-sm">Timpanograma</label>
                <select class="form-select form-select-sm"
                  v-model="imp.tipoTimpanograma" :disabled="soloLectura">
                  <option value="">—</option>
                  <option value="A">A — Normal</option>
                  <option value="As">As — Rigidez</option>
                  <option value="Ad">Ad — Hipercompliance</option>
                  <option value="B">B — Plano (derrame)</option>
                  <option value="C">C — Presión negativa</option>
                </select>
              </div>
              <div class="col-6 col-md-2">
                <label class="form-label form-label-sm">Presión (daPa)</label>
                <input type="number" class="form-control form-control-sm"
                  v-model.number="imp.presionPico" :disabled="soloLectura"/>
              </div>
              <div class="col-6 col-md-2">
                <label class="form-label form-label-sm">Compliancia (ml)</label>
                <input type="number" class="form-control form-control-sm"
                  step="0.1" v-model.number="imp.compliancia" :disabled="soloLectura"/>
              </div>
              <div class="col-6 col-md-2">
                <label class="form-label form-label-sm">Vol. canal (ml)</label>
                <input type="number" class="form-control form-control-sm"
                  step="0.1" v-model.number="imp.volumenEarCanal" :disabled="soloLectura"/>
              </div>
            </div>
            <!-- Reflejos estapediales -->
            <div class="mt-2">
              <small class="fw-bold d-block mb-1" style="font-size:11px">Reflejos estapediales</small>
              <div class="d-flex flex-wrap gap-2">
                <div v-for="hz in ['500','1000','2000','4000']" :key="hz"
                  class="reflejo-item">
                  <small style="font-size:10px">{{ hz }} Hz</small>
                  <select class="form-select form-select-sm"
                    style="width:110px"
                    v-model="imp['reflejoEst' + hz]"
                    :disabled="soloLectura">
                    <option value="">—</option>
                    <option value="presente">Presente</option>
                    <option value="ausente">Ausente</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <label class="form-label form-label-sm">Observación</label>
              <input type="text" class="form-control form-control-sm"
                v-model="imp.observacion" :disabled="soloLectura"
                placeholder="Observaciones..."/>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaOtorrinolaringologia from '@/views/ayuda/AyudaOtorrinolaringologia.vue'
import api from '@/services/api'
import swal2 from 'sweetalert2'

const datosGeneralesVacios = () => ({
  idOrlOido: null,
  lateralidad: 'OU',
  tipoConsulta: 'primera_vez',
  otoscopiaOd: '', otoscopiaOi: '',
  membranaOd: '', membranaOi: '',
  rinneOd: '', rinneOi: '',
  weberLateraliza: '', schwabach: '',
  acufenos: false, acufenosDetalle: '',
  vertigo: false, vertigoTipo: '',
  hipoacusia: false, hipoacusiaTipo: '',
  otalgia: false,
  otorrea: false, otorreaTipo: '',
  observacion: ''
})

const audiometriaVacia = () => ({
  tipoVia: 'VA', oido: 'OD',
  hz250: null, hz500: null, hz1000: null,
  hz2000: null, hz4000: null, hz8000: null,
  pta: null, clasificacion: null
})

const impedanciometriaVacia = () => ({
  oido: 'OD', tipoTimpanograma: '',
  presionPico: null, compliancia: null,
  gradiente: null, volumenEarCanal: null,
  reflejoEst500: '', reflejoEst1000: '',
  reflejoEst2000: '', reflejoEst4000: '',
  observacion: ''
})

export default {
  name: 'OrlOidoForm',
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, default: '' }
  },
  components: { AyudaOtorrinolaringologia },
  data() {
    return {
      tabActual: 'general',
      modoVista: 'editar',
      tabs: [
        { key: 'general',           label: 'Oído general' },
        { key: 'audiometria',       label: 'Audiometría' },
        { key: 'impedanciometria',  label: 'Impedanciometría' }
      ],
      datosGenerales:    datosGeneralesVacios(),
      audiometrias:      [],
      impedanciometrias: [],
      guardando: false,
      showModalHelp: false,
    }
  },
  computed: {
    editable() {
      return this.p_estadoAtencion === 'PENDIENTE' ||
             this.p_estadoAtencion === 'PROCESO'
    },
    soloLectura() {
      return !this.editable || this.modoVista === 'consultar'
    },
    sintomasActivos() {
      const lista = []
      const d = this.datosGenerales
      if (d.acufenos)   lista.push('Acúfenos')
      if (d.vertigo)    lista.push('Vértigo')
      if (d.hipoacusia) lista.push('Hipoacusia')
      if (d.otalgia)    lista.push('Otalgia')
      if (d.otorrea)    lista.push('Otorrea')
      return lista
    }
  },
  mounted() {
    if (!this.editable) this.modoVista = 'consultar'
    this.cargarOrl()
  },
  methods: {
    //  Carga
    async cargarOrl() {
      try {
        const { data } = await api.get(`/orl/oido/${this.p_idAtencion}`)
        if (data.datosGenerales) {
          this.datosGenerales = { ...datosGeneralesVacios(), ...data.datosGenerales }
        }
        this.audiometrias      = data.audiometrias      || []
        this.impedanciometrias = data.impedanciometrias || []
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Error al cargar ORL:', error)
        }
      }
    },

    //  Guardar
    async guardarOrl() {
      this.guardando = true
      try {
        const idUsuario = sessionStorage.getItem('idUsuario') || 1
        const payload = {
          idAtencion:        this.p_idAtencion,
          datosGenerales:    this.datosGenerales,
          audiometrias:      this.audiometrias,
          impedanciometrias: this.impedanciometrias
        }
        await api.post(`/orl/oido?idUsuario=${idUsuario}`, payload)
        swal2.fire({
          title: '¡Éxito!',
          text: 'Datos ORL guardados correctamente.',
          icon: 'success',
          confirmButtonText: 'Ok'
        })
      } catch (error) {
        swal2.fire({
          title: 'Error',
          text: 'No se pudo guardar los datos ORL.',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
        console.error(error)
      } finally {
        this.guardando = false
      }
    },

    //  Limpiar
    limpiarFormulario() {
      this.datosGenerales    = datosGeneralesVacios()
      this.audiometrias      = []
      this.impedanciometrias = []
    },

    //  Audiometría
    agregarAudiometria() {
      this.audiometrias.push(audiometriaVacia())
    },
    eliminarAudiometria(idx) {
      this.audiometrias.splice(idx, 1)
    },
    calcularPTA(aud) {
      const vals = [aud.hz500, aud.hz1000, aud.hz2000, aud.hz4000]
        .filter(v => v !== null && v !== undefined && v !== '')
      if (!vals.length) { aud.pta = null; aud.clasificacion = null; return }
      const prom = vals.reduce((a, b) => a + b, 0) / vals.length
      aud.pta = Math.round(prom * 100) / 100
      aud.clasificacion =
        prom <= 25 ? 'normal'   :
        prom <= 40 ? 'leve'     :
        prom <= 60 ? 'moderada' :
        prom <= 80 ? 'severa'   : 'profunda'
    },
    claseBadgePTA(clasificacion) {
      return {
        normal:   'bg-success',
        leve:     'bg-warning text-dark',
        moderada: 'bg-orange text-white',
        severa:   'bg-danger',
        profunda: 'bg-dark'
      }[clasificacion] || 'bg-secondary'
    },

    //  Impedanciometría
    agregarImpedanciometria() {
      this.impedanciometrias.push(impedanciometriaVacia())
    },
    eliminarImpedanciometria(idx) {
      this.impedanciometrias.splice(idx, 1)
    }
  }
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style src="@/assets/css/especialidades.css"></style>